import SequenceNumberListResourcePagingResultModel from '../../generated/types/model/resource/SequenceNumberListResourcePagingResultModel';

export default class SequenceNumberListResourcePagingResultViewModel extends SequenceNumberListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
